const djSort = {
    CRESCENTE:'CRESCENTE',
    DECRESCENTE:'DECRESCENTE',
    POSICAO_CRESCENTE:'POSICAO_CRESCENTE',
    POSICAO_DECRESCENTE:'POSICAO_DECRESCENTE',
    MAIOR_QUANTIDADE:'MAIOR_QUANTIDADE',
    MENOR_QUANTIDADE:'MENOR_QUANTIDADE',
    NOME_ALFA:'NOME_ALFA',
    NOME_ALFA_R:'NOME_ALFA_R',
    ALFA:'ALFA',
    ALFA_R:'ALFA_R',
}
const sortModosChaves = djSort;

const sortModosTexto = {
    CRESCENTE:   'Do menor para o MAIOR',
    DECRESCENTE: 'Do MAIOR para o menor',
    POSICAO_CRESCENTE:   'Posição crescente',
    POSICAO_DECRESCENTE: 'Posição decrescente',

    MAIOR_QUANTIDADE: 'Maior quantidade',
    MENOR_QUANTIDADE: 'Menor quantidade',

    NOME_ALFA: 'Nome por ordem Alfabética',
    NOME_ALFA_R: 'Nome por ordem Alfabética Reversa',
    ALFA: 'Ordem Alfabética',
    ALFA_R: 'Ordem Alfabética Reversa',
}
const sortModos = {
    'CRESCENTE':    (x,y)=> +x-y,
    'DECRESCENTE':  (x,y)=> -x+y,

    'POSICAO_CRESCENTE':    (x,y)=> +x.position-y.position,
    'POSICAO_DECRESCENTE':  (x,y)=> -x.position+y.position,

    'MAIOR_QUANTIDADE': (x,y)=> -x.users.length+y.users.length,
    'MENOR_QUANTIDADE': (x,y)=>  x.users.length-y.users.length,

    'NOME_ALFA':     (a, b)=>a.nome.localeCompare(b.nome),
    'NOME_ALFA_R':   (a, b)=>b.nome.localeCompare(a.nome),

    'ALFA':     (a, b)=>a.localeCompare(b),
    'ALFA_R':   (a, b)=>b.localeCompare(a),
}

const sortGenerico = {
    CRESCENTE:  (F)=>(x, y) => +F(x)-F(y),
    DECRESCENTE: (F)=>(x, y) => -F(x)+F(y),
    ALFA:        (F)=>(a, b) => F(a).localeCompare(F(b)),
    ALFA_R:      (F)=>(a, b) => F(b).localeCompare(F(a)),
}

export default djSort

export {sortModos, sortGenerico, sortModosChaves, sortModosTexto}
